import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import useFetchClasses from "../../hooks/useFetchClasses";
import useFetchSections from "../../hooks/useFetchSections";
import Select from "react-select";

import { ApiUrl } from "../../../ApiUrl";

const ModalClass = ({ show, onSelectStudent, handleClose }) => {
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSection, setSelectedSection] = useState("");
  const [students, setStudents] = useState([]);
  const [studentLoading, setStudentLoading] = useState(false);
  const [studentError, setStudentError] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  const {
    classes,
    loading: classLoading,
    error: classError,
  } = useFetchClasses();
  const [studentData, setStudentData] = useState([]);
  const [fullStudentData, setFullStudentData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [filters, setFilters] = useState({
    studentName: "",
    admissionNo: "",
    barcode: "",
    classId: "",
    section: "",
    fatherName: "",
    motherName: "",
    schoolAdmissionNo: "",
  });

  // useEffect(() => {
  //   const fetchFullStudentData = async () => {
  //     try {
  //       const academicSessionId = localStorage.getItem("academicSessionId");
  //       if (!academicSessionId) {
  //         console.error("No academic session ID found in local storage");
  //         return;
  //       }
  //       const response = await fetch(
  //         `${ApiUrl.apiurl}STUDENTREGISTRATIONAPI/GetAllSTUDENTList/${academicSessionId}`
  //       );
  //       if (!response.ok) {
  //         throw new Error("Error fetching student data");
  //       }
  //       const data = await response.json();
  //       if (data.data) {
  //         setFullStudentData(data.data);
  //         setStudentData(data.data);
  //       } else {
  //         console.warn("No data found for the given academic session ID");
  //       }
  //     } catch (error) {
  //       console.error("Fetch error:", error);
  //     }
  //   };
  //   fetchFullStudentData();
  // }, []);

  const {
    sections,
    loading: sectionLoading,
    error: sectionError,
  } = useFetchSections(selectedClass);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  // Trigger modal open logic (you might have this somewhere else in your code)
  const handleOpen = () => {
    setIsModalOpen(true);
  };

  // const handleSearch = async () => {
  //   try {
  //     const academicSessionId = localStorage.getItem("academicSessionId");
  //     const orgId = localStorage.getItem("orgId");
  //     const branchId = localStorage.getItem("branchId");

  //     if (!academicSessionId) {
  //       console.error("No academic session ID found in local storage");
  //       return;
  //     }

  //     // Construct the search parameters from the filter values
  //     const queryParams = new URLSearchParams({
  //       studentName: filters.studentName || "",
  //       admissionNo: filters.admissionNo || "",
  //       barcode: filters.barcode || "",
  //       schoolAdmissionNo: filters.schoolAdmissionNo || "",
  //       classId: filters.classId || "",
  //       sectionId: filters.section || "",
  //       fatherName: filters.fatherName || "",
  //       motherName: filters.motherName || "",
  //     }).toString();

  //     //  Fetch filtered data based on search with org_id & branch_id
  //     const response = await fetch(
  //       `${ApiUrl.apiurl}STUDENT_CLASS/STUDENTCLASSRECORDFILTER?academic_year_id=${academicSessionId}&org_id=${orgId}&branch_id=${branchId}&${queryParams}`
  //     );

  //     if (!response.ok) {
  //       throw new Error("Error fetching student data");
  //     }

  //     const data = await response.json();
  //     if (data.data) {
  //       setFullStudentData(data.data);
  //       setStudentData(data.data);
  //     } else {
  //       console.warn("No data found for the given filters");
  //     }
  //   } catch (error) {
  //     console.error("Fetch error:", error);
  //   }
  // };

  const handleSearch = async () => {
    try {
      const academicSessionId = localStorage.getItem("academicSessionId");
      const orgId = localStorage.getItem("orgId");
      const branchId = localStorage.getItem("branchId");

      if (!academicSessionId) {
        console.error("No academic session ID found in local storage");
        return;
      }

      const queryParams = new URLSearchParams({
        studentName: filters.studentName || "",
        admissionNo: filters.admissionNo || "",
        barcode: filters.barcode || "",
        schoolAdmissionNo: filters.schoolAdmissionNo || "",
        classId: filters.classId || "",
        sectionId: filters.section || "", //  send sectionId
        fatherName: filters.fatherName || "",
        motherName: filters.motherName || "",
      }).toString();

      const url = `${ApiUrl.apiurl}STUDENT_CLASS/STUDENTCLASSRECORDFILTER?academic_year_id=${academicSessionId}&org_id=${orgId}&branch_id=${branchId}&${queryParams}`;

      console.log("Searching students with URL:", url);

      const response = await fetch(url);
      const data = await response.json();

      console.log("Search response:", data);

      if (response.ok && Array.isArray(data.data) && data.data.length > 0) {
        setFullStudentData(data.data);
        setStudentData(data.data);
        setStudentError("");
      } else {
        // ✅ clear stale data if no records
        setFullStudentData([]);
        setStudentData([]);
        const msg = data.message || "No Record Found";
        setStudentError(msg);
      }
    } catch (error) {
      console.error("Fetch error:", error);
      setStudentError("Error fetching student data");
      setFullStudentData([]);
      setStudentData([]);
    }
  };

  const getClassName = (classId) => {
    const classObj = classes.find((cls) => cls.id === classId);
    return classObj ? classObj.classname : "N/A";
  };

  // const getSectionName = (sectionId) => {
  //   const sectionObj = sections.find((sec) => sec.id === sectionId);
  //   return sectionObj ? sectionObj.sectionname : "N/A";
  // };

  const getSectionName = (sectionId) => {
    const sectionObj = sections.find((sec) => sec.section_id === sectionId);
    return sectionObj ? sectionObj.sectionname : "N/A";
  };

  // const handleSelectStudent = (student) => {
  //   console.log(student);

  //   const studentId = student.id;
  //   console.log(studentId);
  //   localStorage.setItem("selectedClassStudentId", studentId);

  //   onSelectStudent(student);

  //   handleClose();
  // };

  const handleSelectStudent = (student) => {
    console.log("Selected Student:", student);

    //  Use studentId if available, fallback to id
    const studentId = student.studentId || student.id;

    if (!studentId) {
      console.error("Student ID not found in student object:", student);
      return;
    }

    localStorage.setItem("selectedClassStudentId", studentId);

    onSelectStudent(student);
    handleClose();
  };

  const handleClearFilters = () => {
    setFilters({
      studentName: "",
      admissionNo: "",
      barcode: "",
      classId: "",
      section: "",
      fatherName: "",
      motherName: "",
      schoolAdmissionNo: "",
    });
    setSelectedClass("");
    setSelectedSection("");
    setStudentData(fullStudentData);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  return (
    <Modal
      show={show}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      {/* <Modal.Header closeButton onClick={handleClose}  ></Modal.Header> */}
      <Modal.Header closeButton onClick={handleClose}></Modal.Header>

      <Modal.Body>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card p-0">
                <div className="card-body">
                  <p
                    style={{
                      marginBottom: "0px",
                      textAlign: "center",
                      fontSize: "20px",
                      fontWeight: "700",
                    }}
                  >
                    STUDENT SEARCH
                  </p>
                  <div className="row mb-2">
                    <div
                      className="col-12 d-flex flex-wrap gap-2"
                      // style={{ border: "1px solid #ccc" }}
                    >
                      <button
                        type="button"
                        className="btn btn-primary me-2"
                        style={{ width: "150px" }}
                        onClick={handleSearch}
                      >
                        Search
                      </button>
                      <button
                        type="button"
                        className="btn btn-secondary me-2"
                        style={{ width: "150px" }}
                        onClick={handleClearFilters}
                      >
                        Clear
                      </button>
                      {/* <button
                        type="button"
                        className="btn btn-danger me-2"
                        style={{ width: "150px" }}
                        onClick={handleClose}
                      >
                        Close
                      </button> */}
                      {/* <button
                        type="button"
                        className="btn btn-primary me-2"
                        style={{ width: "150px" }}
                        onClick={() => {
                          window.location.reload(true);
                        }}
                      >
                        Close
                      </button> */}

                      <button
                        type="button"
                        className="btn btn-danger me-2"
                        style={{ width: "150px" }}
                        onClick={handleClose}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                  {/* Search Fields */}
                  <div className="row mt-3">
                    <div className="col-12 col-md-3 mb-2">
                      <label
                        htmlFor="school-admission-no"
                        className="form-label"
                      >
                        {" "}
                        Student Name{" "}
                      </label>
                      <input
                        type="text"
                        name="studentName"
                        value={filters.studentName}
                        onChange={handleInputChange}
                        className="form-control detail"
                        placeholder="Student Name"
                        style={{ height: "38px", padding: "0.375rem 0.75rem" }}
                      />
                    </div>
                    <div className="col-12 col-md-3 mb-2">
                      <label
                        htmlFor="school-admission-no"
                        className="form-label"
                      >
                        {" "}
                        Admission No{" "}
                      </label>
                      <input
                        type="text"
                        name="admissionNo"
                        value={filters.admissionNo}
                        onChange={handleInputChange}
                        className="form-control detail"
                        placeholder="Admission No"
                        style={{ height: "38px", padding: "0.375rem 0.75rem" }}
                      />
                    </div>
                    <div className="col-12 col-md-3 mb-2">
                      <label
                        htmlFor="school-admission-no"
                        className="form-label"
                      >
                        {" "}
                        Student Barcode{" "}
                      </label>
                      <input
                        type="text"
                        name="barcode"
                        value={filters.barcode}
                        onChange={handleInputChange}
                        className="form-control detail"
                        placeholder="Student Barcode"
                        style={{ height: "38px", padding: "0.375rem 0.75rem" }}
                      />
                    </div>
                    <div className="col-12 col-md-3 mb-2">
                      <label
                        htmlFor="school-admission-no"
                        className="form-label"
                      >
                        {" "}
                        Class{" "}
                      </label>
                      <Select
                        options={classes.map((cls) => ({
                          label: cls.classname,
                          value: cls.id,
                        }))}
                        onChange={(selectedOption) => {
                          const classId = selectedOption
                            ? Number(selectedOption.value)
                            : "";
                          setSelectedClass(classId);
                          setFilters((prev) => ({
                            ...prev,
                            classId,
                            section: "", // reset section when class changes
                          }));
                          setSelectedSection("");
                        }}
                        placeholder="Select Class"
                        value={
                          selectedClass
                            ? {
                                label: getClassName(selectedClass),
                                value: selectedClass,
                              }
                            : null
                        }
                      />
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-12 col-md-3 mb-2">
                      <label
                        htmlFor="school-admission-no"
                        className="form-label"
                      >
                        {" "}
                        Section{" "}
                      </label>
                      {/* <Select
                        options={sections.map((sec) => ({
                          label: sec.sectionname,
                          value: sec.section_id,   
                        }))}
                        onChange={(selectedOption) => {
                          const sectionId = selectedOption ? Number(selectedOption.value) : "";
                          setSelectedSection(sectionId);
                          setFilters((prev) => ({
                            ...prev,
                            section: sectionId,
                          }));
                        }}
                        placeholder="Select Section"
                        value={
                          selectedSection
                            ? {
                              label: getSectionName(selectedSection),
                              value: selectedSection,
                            }
                            : null
                        }
                      /> */}
                      <Select
                        options={sections.map((sec) => ({
                          label: sec.sectionname,
                          value: sec.section_id, //  keep numeric id
                        }))}
                        onChange={(selectedOption) => {
                          const sectionId = selectedOption
                            ? Number(selectedOption.value)
                            : "";
                          setSelectedSection(sectionId);
                          setFilters((prev) => ({
                            ...prev,
                            section: sectionId, //  store numeric id
                          }));
                        }}
                        placeholder="Select Section"
                        value={
                          selectedSection
                            ? {
                                label: getSectionName(selectedSection),
                                value: selectedSection,
                              }
                            : null
                        }
                      />
                    </div>
                    <div className="col-12 col-md-3 mb-2">
                      <label
                        htmlFor="school-admission-no"
                        className="form-label"
                      >
                        {" "}
                        Father's Name{" "}
                      </label>
                      <input
                        type="text"
                        name="fatherName"
                        value={filters.fatherName}
                        onChange={handleInputChange}
                        className="form-control detail"
                        placeholder="Father's Name"
                        style={{ height: "38px", padding: "0.375rem 0.75rem" }}
                      />
                    </div>
                    <div className="col-12 col-md-3 mb-2">
                      <label
                        htmlFor="school-admission-no"
                        className="form-label"
                      >
                        {" "}
                        Mother's Name{" "}
                      </label>
                      <input
                        type="text"
                        name="motherName"
                        value={filters.motherName}
                        onChange={handleInputChange}
                        className="form-control detail"
                        placeholder="Mother's Name"
                        style={{ height: "38px", padding: "0.375rem 0.75rem" }}
                      />
                    </div>
                  </div>
                  {/* Students Table */}
                  <div className="table-responsive mt-3">
                    <table className="table table-bordered table-striped">
                      <thead>
                        <tr>
                          <th>Student Name</th>
                          <th>Admission No</th>
                          <th>Class</th>
                          <th>Section</th>
                          <th>Father Name</th>
                          <th>Mother Name</th>
                          <th>Student Barcode</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                    
                      <tbody>
                        {studentData.map((student, index) => {
                          return (
                            <tr key={index}>
                              <td>{student.studentname}</td>
                              <td>{student.rollno}</td>
                              <td>{student.classname}</td>
                              <td>{student.sectionname}</td>
                              <td>{student.father_name}</td>
                              <td>{student.mother_name}</td>
                              <td>{student.barcode}</td>
                              <td>
                                <button
                                  className="btn btn-success"
                                  onClick={() => handleSelectStudent(student)}
                                >
                                  Select
                                </button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ModalClass;
